import styled from 'styled-components';
import { PencilFill } from '@styled-icons/bootstrap/PencilFill';

const NonMonitoredAssetInfoParent = styled.div`
  height: ${(props) => (props.fullHeight ? '100%' : 'auto')};

  .popover-parent {
    visibility: hidden;
  }

  .field-block:hover {
    .popover-parent {
      visibility: visible !important;
    }
  }
`;

const CustomField = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 4px;
  padding-left: 4px;
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-Button--primary {
    margin-left: 12px;
  }
  .Polaris-Button {
    margin-top: 12px;
  }
`;

export { NonMonitoredAssetInfoParent, CustomField };
